import React, { useContext, useEffect, useState } from 'react';
import moment from 'moment';
import './TrackerSection.scss';
import VerticalProgress from '../../../components/VerticalProgress/VerticalProgress';
import OrderStatusContainer from './OrderStatusContainer';
import orderStatus from '../../../utils/orderStatus';
import { OrderDetailsContext } from '../../../context/OrderDetailsContext';

const TrackerSection = () => {
  const [progress, setProgress] = useState(0);
  const [completedProgress, setCompletedProgress] = useState(0);
  const { orderDetail, orderType } = useContext(OrderDetailsContext);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(0);
  // const [nandusPromise, setNandusPromise] = useState(0);
  const [orderCompleted, setOrderCompleted] = useState(false);
  const [orderDispatched, setOrderDispatched] = useState(false);
  const [orderStatusHistories, setOrderStatusHistories] = useState([]);
  const [deliveryDate, setDeliveryDate] = useState(0);
  const [minsBeforeCheck, setMinsBeforeCheck] = useState(0);
  const [deliveryBeforeSlottedTime, setDeliveryBeforeSlottedTime] =
    useState('false');
  const [orderIsCancelled, setOrderIsCancelled] = useState('false');

  useEffect(() => {
    if (orderType === 'slotted') {
      setStart(orderDetail?.response?.timeSlotStart);
      setEnd(orderDetail?.response?.timeSlotEnd);
      // setNandusPromise(orderDetail?.response?.timeSlotEnd);
    } else {
      setStart(orderDetail?.response?.sourceCreatedOn);
      setEnd(orderDetail?.response?.deliveryDatetime);
      // setNandusPromise(orderDetail?.response?.deliveryDatetime);
    }
  }, [orderType, orderDetail]);

  useEffect(() => {
    var endingDate = new Date(end);
    setMinsBeforeCheck(moment(endingDate).subtract(15, 'minutes'));
  }, [end, orderType]);

  // sort the order statuses acc to id
  const sortedOrderStatus = orderStatus?.sort(function (a, b) {
    var c = a.id;
    var d = b.id;
    return c - d;
  });

  const cd = new Date();
  const currentDate = cd.valueOf();

  var sp1 = end - start;
  var sp2 = currentDate - start;

  var od1 = end - start;
  var od2 = deliveryDate - start;

  useEffect(() => {
    if (orderCompleted && deliveryDate !== 0) {
      setProgress(Math.round((od2 / od1) * 10000) / 100);
    } else {
      if (progress < 100) {
        const timer = setTimeout(
          () => setProgress(Math.round((sp2 / sp1) * 10000) / 100),
          2000
        );
        return () => clearTimeout(timer);
      } else if (progress > 100) {
        setProgress(101);
      }
    }
    // eslint-disable-next-line
  }, [end, start, cd]);

  useEffect(() => {
    if (orderCompleted) {
      setCompletedProgress(progress);
    }
  }, [orderCompleted, orderDetail, progress]);

  // get all the available order status histories
  useEffect(() => {
    setOrderStatusHistories(orderDetail?.response?.orderStatusHistories);
  }, [orderDetail]);

  // sort the order histories with timestamp
  const sortedOrderStatusHistories = orderStatusHistories?.sort(function (
    a,
    b
  ) {
    var c = a.syncedOn;
    var d = b.syncedOn;
    return c - d;
  });

  useEffect(() => {
    // check if delivery is done

    //* old logic
    //  sortedOrderStatusHistories
    //    ?.filter((orderStatuses) => orderStatuses.status === 'Completed')
    //    ?.map((order) => {
    //      setOrderCompleted(true);
    //      setDeliveryDate(order?.syncedOn);
    //    });

    //* new way
    if (orderDetail?.response?.orderState === 'Completed') {
      setOrderCompleted(true);
      setDeliveryDate(orderDetail?.response.lastUpdatedStatusOn);
    }
    // if (orderDetail.response.orderState === 'TRIP START') {
    //   setOrderDispatched(true);
    // }

    sortedOrderStatusHistories
      ?.filter((orderStatuses) => orderStatuses.status === 'TRIP START')
      ?.map((order) => {
        setOrderDispatched(true);
      });
  }, [orderDetail, sortedOrderStatusHistories]);

  //* if delivery is done than send push notifications
  // const [errorMsg, setErrorMsg] = useState('');
  // const [delayColor, setDelayColor] = useState('');
  // useEffect(() => {
  //   if (orderCompleted && deliveryDate !== 0) {
  //     if (deliveryDate < nandusPromise) {
  //       setErrorMsg('Yay..we delivered ahead of promised time!');
  //       setDelayColor('no');
  //     } else if (deliveryDate === nandusPromise) {
  //       setErrorMsg(`Yupp. We delivered on time.`);
  //       setDelayColor('no');
  //     } else if (deliveryDate > nandusPromise) {
  //       setErrorMsg(`We apologise for the delay in delivering.`);
  //       setDelayColor('yes');
  //     }
  //   }
  // }, [orderCompleted, deliveryDate, nandusPromise, orderDetail]);

  useEffect(() => {
    if (orderType === 'slotted') {
      if (orderDetail?.response?.orderState === 'Completed') {
        if (
          orderDetail?.response?.lastUpdatedStatusOn <=
          orderDetail?.response?.timeSlotStart
        ) {
          setDeliveryBeforeSlottedTime('true');
        }
      }
    }

    if (orderDetail?.response?.orderState === 'Cancelled') {
      setOrderIsCancelled('true');
    }
  }, [orderDetail, orderType]);

  return (
    <div className="trackerContainer">
      {deliveryBeforeSlottedTime === 'true' && (
        <div className="errorMsgContainerOuter">
          <div className={`errorMsgContainer greenFont`}>
            Your order was delivered before your delivery slot !
            {/* <span className="trophy blinker">
              <i className="fad fa-trophy-alt"></i>
            </span> */}
          </div>
        </div>
      )}

      {/*
      {!orderCompleted ? (
        <>
          {orderIsCancelled === 'true' ? (
            <div className="errorMsgContainerOuter">
              <div className={`errorMsgContainer amberFont`}>
                Your order is Cancelled.
              </div>
            </div>
          ) : (
            <>
              {progress >= 101 && (
                <div className="errorMsgContainerOuter">
                  <div className={`errorMsgContainer amberFont`}>
                    We apologise, your order maybe slightly delayed.
                  </div>
                </div>
              )}
            </>
          )}
        </>
      ) : (
        ''
      )} */}

      <section className="trackerSection">
        <div className="orderTrackerSection">
          <div
            className="orderTrackerStatusContainer"
            style={{ position: 'relative' }}
          >
            <ul className="sessions">
              {sortedOrderStatus.map((order) => (
                <OrderStatusContainer
                  order={order}
                  key={order.id}
                  orderType={orderType}
                  orderCompleted={orderCompleted}
                  orderDispatched={orderDispatched}
                  minsBeforeCheck={minsBeforeCheck}
                  deliveryBeforeSlottedTime={deliveryBeforeSlottedTime}
                  orderIsCancelled={orderIsCancelled}
                />
              ))}
            </ul>
            {/* {orderIsCancelled === 'true' ? (
              ''
            ) : (
              <>
                {orderType === 'slotted' ? (
                  <>
                    {deliveryBeforeSlottedTime === 'true' ? (
                      ''
                    ) : (
                      <p className="timeinfo">
                        {moment(orderDetail?.response.timeSlotEnd).format(
                          'LT'
                        ) !== 'Invalid date'
                          ? moment(orderDetail?.response.timeSlotEnd).format(
                              'LT'
                            )
                          : '...'}
                        <br />
                        Nandus Promise
                      </p>
                    )}
                  </>
                ) : (
                  <p className="timeinfo">
                    {moment(orderDetail?.response.deliveryDatetime).format(
                      'LT'
                    ) !== 'Invalid date'
                      ? moment(orderDetail?.response.deliveryDatetime).format(
                          'LT'
                        )
                      : '...'}
                    <br />
                    Nandus Promise
                  </p>
                )}
              </>
            )} */}

            {/* {orderCompleted && progress >= 101 ? (
              <p className="lateDeliveryInfo" style={{ width: '100%' }}>
                Delivered At - {moment(deliveryDate).format('LT')}
              </p>
            ) : (
              ''
            )} */}
          </div>
        </div>
        {deliveryBeforeSlottedTime === 'true' ? (
          ''
        ) : (
          <div className="timeTrackerSection">
            <VerticalProgress
              progress={orderCompleted ? completedProgress : progress}
              orderStatus={orderStatus}
              orderIsCancelled={orderIsCancelled}
              orderDispatched={orderDispatched}
            />
          </div>
        )}
      </section>
    </div>
  );
};

export default TrackerSection;
